<template>
  <div>
    <iframe width="100%" height="650px"
      src="https://lookerstudio.google.com/embed/reporting/264711aa-5b5e-48cb-a90f-2f3972ca5045/page/p_z5s6xxb5zd"
      frameborder="0" style="border:0" allowfullscreen></iframe>
  </div>
</template>

<script>
export default {
}
</script>
